import { AdvancedTourStep } from '../shared-types';
import { TaskTourProps } from './task-tour-props';

export function getRateLimiterTourSteps({
	defaultStyles,
}: Readonly<TaskTourProps>): AdvancedTourStep[] {
	return [
		{
			id: 'rate-limit',
			selector: '[data-tour="rate-limit"]',
			content: 'This is used to enable a rate based limit to execution.',
		},
		{
			id: 'rate-selection',
			selector: '[data-tour="rate-selection"]',
			content: 'Required: Set a rate limit on a timely basis.',
		},
		{
			id: 'rate-limit-amount',
			selector: '[data-tour="rate-limit-amount"]',
			content:
				'Required: Set a rate limit to apply to the timely basis selected previously (Amount of items per time range).',
		},
		{
			id: 'daily-limit',
			selector: '[data-tour="daily-limit"]',
			content:
				'This is used to enable or disable a daily execution limit that resets at midnight every day.',
		},
		{
			id: 'daily-limit-amount',
			selector: '[data-tour="daily-limit-amount"]',
			content:
				'Required: This is the amount of daily executions that would be allowed before rate limiting is applied to further executions.',
		},
		{
			id: 'backlog-warning',
			selector: '[data-tour="backlog-warning"]',
			content:
				'This is used to enable or disable a backlog queue warning notification threshold. This setting would monitor the amount of executions currently in queue being limited. Once the amount of executions has reached this set point a notification can be setup to be sent out as a warning to allow steps to be taken to reduce the amount of unprocessed executions.',
		},
		{
			id: 'warning-threshold',
			selector: '[data-tour="warning-threshold"]',
			content: 'Required:	This is where the backlog queue warning notification threshold is set.',
		},
		{
			id: 'backlog-overflow',
			selector: '[data-tour="backlog-overflow"]',
			content:
				'This is used to enable or disable a backlog queue overflow threshold. When it is off the backlog holds up to 1000 executions. When it is on, the backlog is limited to the threshold below, and a notification can be setup to be sent out when the backlog overflows.',
		},
		{
			id: 'overflow-threshold',
			selector: '[data-tour="overflow-threshold"]',
			content:
				'Required: This is the most executions that may wait in the backlog while the rate limit is reached (1 to 1000). Once the backlog is this long, new executions fail with the rate limit as the reason. This stops the flow from endlessly building a queue when the limit is exceeded. Only asynchronous executions wait in the backlog, a synchronous execution fails as soon as the limit is reached.',
		},
	].map(tourItem => ({ ...tourItem, styles: defaultStyles }));
}
